// extracted by mini-css-extract-plugin
export default {"page":"DeployPool_page__dGa2N","create-holder":"DeployPool_create-holder__6-23j"};